import { dataTable } from '@/components/DataTable/locales/data-table.es'
import { socialAnalytics } from '@/features/social-analytics/locales/social-analytics.es'
import { socialPosts } from '@/features/social-posts/locales/social-posts.es'
import { socialAccounts } from '@/features/social-accounts/locales/social-accounts.es'
import { nativeContent } from '@/features/native-content/locales/native-content.es'
import { trendFilter } from '@/features/trend-filter/locales/trend-filter.es'
import { keywordPositioning } from '@/features/keyword-positioning/locales/keyword-positioning.es'
import { contentAmplification } from '@/features/content-amplification/locales/content-amplification.es'
import { keywordGap } from '@/features/keyword-gap/locales/keyword-gap.es'
import { knowledgeBase } from '@/features/knowledge-base/locales/knowledge-base.es'
import { editor } from '@/components/editor/locale/editor.es'
import { selectWithSearch } from '@/components/SelectWithSearch/locales/select-with-search.es'
import { errorBoundary } from '@/components/shared/locales/error-boundary.es'
import { versionUpdate } from '@/components/shared/locales/version-update.es'
import { agent } from '@/features/agent/locales/agent.es'
import { auth } from '@/features/auth/locales/auth.es'
import { bulkGeneration } from '@/features/bulk-generation/locales/bulk-generation.es'
import { contentPlan } from '@/features/content-plan/locales/content-plan.es'
import { contentGenerator, contentOptimization } from '@/features/content-generator/locales/content-generator.es'
import { contentList } from '@/features/content-list/locales/content-list.es'
import { dashboard } from '@/features/dashboard/locales/dashboard.es'
import { data } from '@/features/data/locales/data.es'
import { errors } from '@/features/errors/locales/errors.es'
import { keywordResearch } from '@/features/keyword-research/locales/keyword-research.es'
import { landingPage } from '@/features/landing-page-generator/locales/landing-page.es'
import { brandVoice } from '@/features/brand-voice/locales/brand-voice.es'
import { brandIdentity } from '@/features/brand-identity/locales/brand-identity.es'
import { integrations } from '@/features/integrations/locales/integrations.es'
import onboarding from '@/features/onboarding/locales/onboarding.es'
import { organizationConfiguration, companySettings } from '@/features/organization-configuration/locales/organization-configuration.es'
import { kanban } from '@/features/performance-home/locales/kanban.es'
import { performanceHome } from '@/features/performance-home/locales/performance-home.es'
import { prospectAudit } from '@/features/prospect-audit/locales/prospect-audit.es'
import { seoAudit } from '@/features/seo-audit/locales/seo-audit.es'
import { setupProgress } from '@/features/setup-progress/locales/setup-progress.es'
import { superAdmin } from '@/features/super-admin/locales/super-admin.es'
import { tags } from '@/features/tags/locales/tags.es'
import { deliverables } from '@/features/deliverables/locales/deliverables.es'
import { oauthConsent } from '@/features/oauth-consent/locales/oauth-consent.es'
import { basePages } from './shared/base-pages.es'
import { common } from './shared/common.es'
import { layout } from './shared/layout.es'

export const es = {
  agent,
  auth,
  brandIdentity,
  brandVoice,
  bulkGeneration,
  contentGenerator,
  contentOptimization,
  contentPlan,
  contentList,
  dashboard,
  basePages,
  common,
  data,
  companySettings,
  dataTable,
  editor,
  errorBoundary,
  errors,
  versionUpdate,
  integrations,
  kanban,
  keywordResearch,
  landingPage,
  language: layout.language,
  layout: {
    dashboard: layout.dashboard,
  },
  onboarding,
  organizationConfiguration,
  performanceHome,
  selectWithSearch,
  seoAudit,
  setupProgress,
  sidebar: layout.sidebar,
  sidebarNav: layout.sidebarNav,
  superAdmin,
  tags,
  knowledgeBase,
  prospectAudit,
  deliverables,
  keywordGap,
  contentAmplification,
  keywordPositioning,
  trendFilter,
  oauthConsent,
  nativeContent,
  socialAccounts,
  socialPosts,
  socialAnalytics,
} as const
